module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    ref: "prefSelector",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      }
    }
  }, [_vm._t("not-selected", [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("選んで下さい…")])]), _vm._v(" "), _vm._l((_vm.prefs), function(p) {
    return _c('option', {
      domProps: {
        "value": p,
        "selected": p === _vm.value
      }
    }, [_vm._v(_vm._s(p))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b7966f9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrefectureSelector.vue
// module id = 85
// module chunks = 1 2